<template>
	<i v-if="loading" class="far fa-spinner"></i>
	<div v-else-if="list.length > 0" class="tw-grid tw-grid-cols-2 tw-gap-x-3 tw-gap-y-1">
		<div v-for="(item, i) in list" :key="item.id">
			<a target="_blank" :href="`/api/v4/certificate/user/${item.public_identifier}/download`"
			   :class="['tw-flex tw-items-center tw-cursor-pointer tw-border tw-border-white tw-p-4 tw-rounded hover:tw-border-gray-0', {'tw-mb-6' : i !== list.length - 1}]"
			>
				<i class="far fa-external-link tw-text-xl tw-mr-4"></i>
				<div class="tw-pr-5">
					<p class="tw-font-semibold">{{item.certificate.name}}</p>
					<p class="tw-text-sm tw-text-gray-400 tw-font-light">{{ $t('profile.certificate') }}</p>
				</div>
			</a>
		</div>
	</div>
	<p v-else class="tw-text-gray-400">{{ $t('profile.no_user_certificates') }}</p>
</template>

<script>
export default {
	name: 'CertificateList',
	props: ['profile'],
	data() {
		return {
			list: [],
			loading: true,
		}
	},

	methods: {
		getCertificates() {
			this.loading = true;
			axios.get(`/api/v4/certificate/user/me`).then((response) => {
				this.list = response.data.data;
				this.loading = false;
			});
		},
	},
	mounted() {
		this.getCertificates();
	}
}
</script>